const projects = [
    {
        id: 1,
        title: "Re-Source",
        shortDescription: "Developed and published a link organization app for simplified resource management",
        longDescription: "Designed and developed a link organization app with automatic meta-data parsing and AI categorization, released to the Play Store for Android devices",
        tags: [ "Flutter", "Mobile Development", "Gemini"],
        image: "assets/projects/re-source.png",
        link: ["https://play.google.com/store/apps/details?id=com.technicallyti.resource"],
        repo: "",
    },
    {
        id: 2,
        title: "Tessera Web",
        shortDescription: "Designed and developed the company website for Tessera Studios",
        longDescription: "Designed and developed the company website for Tessera Studios.",
        tags: ["React", "Tailwind", "Typescript", "Figma"],
        image: "assets/projects/tessera.png",
        link: "https://tessera-studios.com",
        repo: "",
    },
    {
        id: 3,
        title: "Eye Disease Classifier",
        shortDescription: "Machine learning project designed to automatically detect and classify common eye diseases from retinal images",
        longDescription: "Machine learning project designed to automatically detect and classify common eye diseases from retinal images.",
        tags: ["Python", "Streamlit"],
        image: "assets/projects/eye-disease-classifier.png",
        link: "https://eye-disease-classifier-taiga.streamlit.app",
        repo: "",
    },
    {
        id: 4,
        title: "Pellucid Web",
        shortDescription: "Designed & developed the company website for Pellucid IT",
        longDescription: "Designed and developed the company website for Pellucid IT.",
        tags: ["Drupal"],
        image: "assets/projects/pellucid.png",
        link: "https://pellucidit.com/",
        repo: "",
    },
    {
        id: 5,
        title: "Recall Rumble",
        shortDescription: "Engaging memory matching game designed to test your recall abilities!",
        longDescription: "Recall Rumble is an engaging memory-matching game designed to test your recall abilities! Challenge yourself and see how well you can match your cards.",
        tags: ["HTML", "CSS", "JavaScript"],
        image: "assets/projects/recall-rumble.png",
        link: "https://taigati.github.io/Recall-Rumble/",
        repo: "https://github.com/TaigaTi/Recall-Rumble",
    },
    {
        id: 6,
        title: "JobWize",
        shortDescription: "A dynamic job application tracker designed to streamline career journey management",
        longDescription: "JobWize is a dynamic job application tracker designed to streamline the process of managing your career journey. It offers intuitive features for organization, analysis, and automation, making it easier to keep track of applications, resumes, and gain insights through user analytics.",
        tags: ["Expo", "React Native", "Firebase"],
        image: "assets/projects/jobwize.png",
        link: "https://www.figma.com/proto/omHDfhqrWlSvejzwmBXT9n/JobWize?node-id=8-41&node-type=FRAME&t=ixY3A49jXTDsM8BZ-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=8%3A41",
        repo: "https://github.com/TaigaTi/JobWize",
    },
    {
        id: 7,
        title: "InSites",
        shortDescription: "A social media dashboard app designed to track user analytics across various social media platforms",
        longDescription: "InSites is a social media dashboard app designed to track user analytics across various social media platforms. InSites provides users with a comprehensive dashboard interface to monitor their social media performance and engagement metrics. The app offers insights into key metrics such as follower count, post interactions, and audience demographics across platforms like Instagram, Twitter, and more.",
        tags: ["Expo", "React Native", "Firebase"],
        image: "assets/projects/insites.png",
        link: "",
        repo: "https://github.com/TaigaTi/InSites",
    },
    {
        id: 8,
        title: "Simon Says",
        shortDescription: "A simple game of memory and pattern recognition",
        longDescription: "A simple game of memory and pattern recognition. The game features a series of buttons that the user must remember and repeat in the correct order.",
        tags: ["React", "HTML", "CSS", "JavaScript"],
        image: "assets/projects/simon-says.png",
        link: "https://taigati.github.io/Simon-Says/",
        repo: "https://github.com/TaigaTi/Simon-Says",
    },
    {
        id: 9,
        title: "Bool School Learning Tool",
        shortDescription: "Learning tool designed to teach Boolean Algebra concepts",
        longDescription: "Implementation of a learning tool designed to instruct Boolean Algebra concepts using a combination of text, videos, slideshows, and quizzes. This initiative is part of a collaborative group project within the framework of a Computer Systems Architecture Course.",
        tags: ["HTML", "CSS", "JavaScript", "Bootstrap"],
        image: "assets/projects/bool-school.png",
        link: "https://taigati.github.io/The-Bool-School-Learning-Tool/",
        repo: "https://github.com/TaigaTi/The-Bool-School-Learning-Tool",
    },
    {
        id: 10,
        title: "Watermelon Store",
        shortDescription: "An e-commerce platform for buying and selling watermelon products",
        longDescription: "An e-commerce platform for buying and selling watermelon products. The platform allows users to browse, search, and purchase watermelon products with a user-friendly interface.",
        tags: ["Angular", "NestJS", "Prisma", "Docker"],
        image: "assets/projects/watermelon-store.png",
        link: "",
        repo: "https://github.com/TaigaTi/Watermelon-Store",
    },
    {
        id: 11,
        title: "Equity Care",
        shortDescription: "A simple health consultancy website design",
        longDescription: "For my final project in an Entrepreneurship for Computer Scientists course, we were given 48 hours to research a problem, build a business based on that problem and create a website based on the problem/business. ",
        tags: ["HTML", "CSS", "JavaScript"],
        image: "assets/projects/equity-care.png",
        link: "https://taigati.github.io/Equity-Care/",
        repo: "https://github.com/TaigaTi/Equity-Care",
    }, {
        id: 12,
        title: "Impossible Tic Tac Toe",
        shortDescription: "A game of Tic Tac Toe built using the Minimax Algorithm!",
        longDescription: "A simple game of tic-tac-toe. The game features a grid of buttons that the user can click to place their symbol (X or O) in a row, column, or diagonal to win the game.",
        tags: ["React", "HTML", "CSS", "JavaScript"],
        image: "assets/projects/tictactoe.png",
        link: "https://tictactoe-2.onrender.com",
        repo: "https://github.com/TaigaTi/TicTacToe-2",
    },
    {
        id: 13,
        title: "District 6 AR Demo",
        shortDescription: "AR Demo created for District 6's Booth at the 2025 UWI Job Fair",
        longDescription: "AR Demo created for District 6's Booth at the 2025 UWI Job Fair",
        tags: ["MindJS"],
        image: "assets/projects/d6-ar.png",
        link: "https://taigati.github.io/D6-AR-Demo/",
        repo: "https://github.com/TaigaTi/D6-AR-Demo",
    },

];

export default projects;